import types from './types'

export const loadConfig = () => ({ type: types.CONFIG_LOAD_ATTEMPT })
export const loadConfigSuccess = (data) => ({ type: types.CONFIG_LOAD_SUCCESS, data })
export const loadConfigFailure = (error, code) => ({ type: types.CONFIG_LOAD_FAILURE, error, code })

export const loadServiceHealthSuccess = (data) => ({ type: types.SERVICE_HEALTH_LOAD_SUCCESS, data })
